import React, {useMemo, useState} from "react";
import { routes } from "../routes";
import {useOfflineAssets} from '../pages/offline/useOfflineAssets'
import { useUser } from "../utilities/useUser";
import { useHistory } from "react-router-dom";
import { useTheme } from "../withRoot";
import { Menu, MenuItem, Avatar} from "@material-ui/core";
import { AdminService } from "../../src/services/AdminService";
import { AuthenticationService } from "../../src/services/AuthenticationService";

interface Props{
	adminMode?: boolean;
}

export function UserAvatar(props: Props){
	const { adminMode} = props;
	const userContext = useUser();
	const {onlineMode, toggleOfflineMode } = useOfflineAssets();
	const history = useHistory();
	const theme = useTheme();
	
	const { offlineUser, onlineUser } = userContext;
	const [userMenu, setUserMenu] = useState<HTMLElement | undefined>(undefined);
	const user = useMemo(() => onlineUser ? onlineUser : offlineUser  ,[onlineUser, offlineUser])

	const handleSignOutClick = async() => {
		if (user && user.inAdminImpersonationMode) {
			const result = await AdminService.stopImpersonation();
			if (result.success) {
				userContext.updateUser(result.data);
				window.location.assign(routes.app.libraryHomePage);
			} else {
				window.location.reload();
			}
		} else {
			const windowLocation = await AuthenticationService.signOut();

			userContext.updateUser(null);
			if (windowLocation) {
				window.location.assign(routes.public.signInPage);
			}
		}
	}

	if(!user){
		return null
	}

	return (
		<React.Fragment>
			<Avatar onClick={(e) => setUserMenu(e.currentTarget)} style={{ cursor: 'pointer', backgroundColor: theme.palette.primary.light }} src={user.profileImageUrl ?? undefined}>
				{user.firstName.charAt(0)}
				{user.lastName.charAt(0)}
			</Avatar>
			<Menu anchorEl={userMenu} open={Boolean(userMenu)} onClose={() => setUserMenu(undefined)}>
				{!adminMode && <MenuItem onClick={() => history.push(routes.app.settings)} disabled={!onlineMode}>Settings</MenuItem>}
				{
					onlineMode
					?
					<MenuItem onClick={() => toggleOfflineMode(true)}>Go Offline</MenuItem>
					:
					<MenuItem onClick={() => toggleOfflineMode(false)}>Go Online</MenuItem>
				}
				<MenuItem onClick={() => handleSignOutClick()} disabled={!onlineMode}>Sign Out</MenuItem>
			</Menu>
		</React.Fragment>
	);
}